// import palette from '../../../lib/styles/palette';
// import styled from 'styled-components';
import React, { useRef, useState } from 'react';

// import { Input, Input, RowOutput, RowSelect } from './PowerCalculationJIS';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeBody } from '../../../modules/conveyor/conveyorWriteSlice';
import { plummerBlocks } from '../../../lib/data/plummerBlock-data';

import { Input, Output, Select } from '../common/SingleInput';
import AlertLabel from '../../common/AlertLabel';
import { getMinPulleyDia, getPulleyWeight, getShaftDia, standardPulleyDia } from '../../../lib/data/pulley-data-new';

const DrivePulleyFormSingle = ({ pulleys, belt, drives }) => {
    const dispatch = useDispatch();
    const language = useSelector((state) => state.language.language);
    const isEN = language === 'EN' ? true : false;
    const isJP = language === 'JP' ? true : false;

    const beltSpeed = useSelector((state) => state.conveyorWrite.body.input.beltSpeed);
    const beltWidth = useSelector(state => state.conveyorWrite.body.input.beltWidth);
    const minPulleyDiaByBelt = useSelector((state) => state.conveyorWrite.body.belt?.minPulleyDia);
    const tightSideTension = useSelector(state => state.conveyorWrite.body.drives[0]?.tightSideTension?.load);
    const slackSideTension = useSelector(state => state.conveyorWrite.body.drives[0]?.slackSideTension?.load);

    const [, setDrivePulleys] = useState([]);
    const [nonDrivePulleys, setNonDrivePulleys] = useState([]);
    const [firstPulley, setFirstPulley] = useState(null);

    const brgDiaRankingRef = useRef(
        plummerBlocks.map((item) => ({
            text: `${Number(item.dia).toFixed(1)}`,
            value: item.dia,
        })),
    );

    const standardPulleyDiaRef = useRef(
        standardPulleyDia.map((item) => ({
            text: item,
            value: item,
        })),
    );

    const separateByApplication = (pulleys) => {
        if (!pulleys || !Array.isArray(pulleys) || !pulleys.length) {
            return { drivePulleys: [], nonDrivePulleys: [] };
        }

        const drivePulleys = pulleys.filter((pulley) => pulley?.application?.includes('Drive'));
        const nonDrivePulleys = pulleys.filter(
            (pulley) => pulley?.application && !pulley?.application?.includes('Drive'),
        );

        return { drivePulleys, nonDrivePulleys };
    };

    useEffect(() => {
        if (!pulleys) {
            // 리덕스 초깃값이 pulleys: null 이므로 즉, pulleys에 아무것도 없으면(처음 풀리를 작성하면)
            const initialDrivePulley = {
                id: 1,
                beltWidth,
                application: '1st Drive',
                pulleyTypeCategory: 'A',
                numberOfPulley: 1,
            };
            setDrivePulleys([initialDrivePulley]);
            setFirstPulley(initialDrivePulley);
        } else {
            const { drivePulleys, nonDrivePulleys } = separateByApplication(pulleys);
            setDrivePulleys(drivePulleys);
            setNonDrivePulleys(nonDrivePulleys);

            // 풀리 중에 drive pulley가 없는 경우도 있을 수 있으므로
            if (drivePulleys.length > 0) {
                setFirstPulley(drivePulleys[0]);
            } else {
                setFirstPulley({
                    id: 1,
                    beltWidth,
                    application: '1st Drive',
                    pulleyTypeCategory: 'A',
                    numberOfPulley: 1,
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // 처음 마운트될 때만 실행

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFirstPulley((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSelection = (e) => {
        const { name, value } = e.target;
        setFirstPulley((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


    /* 1st Drive - Resultant Force, Torque */
    useEffect(() => {
        if (!belt?.minPulleyDia || !drives[0].tightSideTension || !drives[0].slackSideTension) return;

        const T1 = Number(drives[0]?.tightSideTension?.load);
        const T2 = Number(drives[0]?.slackSideTension?.load);
        const radialForce = T1 + T2;
        // console.log('radial Force : ', radialForce);
        const resultantForce = Math.ceil(radialForce * 1.04);

        // 필요 최소 직경을 대략적으로 계산한다.
        const margin = Number(beltWidth) > 1400 ? 150 : 100;
        const minDiaByShapeRatio = (Number(beltWidth) + margin) / 2.5;
        const minDiaByBelt = belt?.minPulleyDia['A'];
        const minPulleyDia = Math.max(minDiaByBelt, minDiaByShapeRatio);

        // Tentative Torque 계산
        const tentativeTorque = Math.ceil(((T1 - T2) * 1.1 * minPulleyDia) / 2 / 10); // N-m => N-cm 단위 환산

        setFirstPulley((prev) => ({
            ...prev,
            resultantForce,
            tentativeTorque,
        }));
    }, [beltWidth, belt, drives, ]);

    /* Shaft Dia. 계산 */
    useEffect(() => {
        // if (!firstPulley) return;
        if (
            !firstPulley?.resultantForce ||
            !firstPulley?.torque ||
            !firstPulley?.eccentricFactor ||
            !firstPulley?.beltWidth
        )
            return;

        const resultantForce = firstPulley?.resultantForce;
        const torque = firstPulley?.torque;
        const eccentricFactor = firstPulley?.eccentricFactor;
        const beltWidth = firstPulley?.beltWidth;
        const isDrive = true;

        const [brgDistance, webDistance, momentArm, maxMoment, hubDiaByStress, hubDiaByDeflection, hubDiaCalculated] =
            getShaftDia(resultantForce, torque, eccentricFactor, beltWidth, isDrive);

        const [, , , , , , brgDiaCalculated] = getShaftDia(
            resultantForce * 0.4,
            torque,
            eccentricFactor,
            beltWidth,
            isDrive,
        );

        setFirstPulley((prev) => ({
            ...prev,
            brgDistance,
            webDistance,
            momentArm,
            maxMoment,
            hubDiaByStress,
            hubDiaByDeflection,
            hubDiaSelected: hubDiaCalculated,
            brgDiaCalculated,
        }));
    }, [
        firstPulley?.beltWidth,
        firstPulley?.eccentricFactor,
        firstPulley?.resultantForce,
        firstPulley?.torque,
    ]);

    /* Bearing, PlummerBlock 선정 */
    useEffect(() => {
        if (!firstPulley?.brgDiaSelected) return;
        
        const obj = plummerBlocks.find(({ dia }) => dia >= Number(firstPulley.brgDiaSelected)); // *10은 단위 환산(cm -> mm)

        setFirstPulley((prev) => ({
            ...prev,
            plummerBlockNumber: obj.model,
            plummerBlockWeight: obj.weight,
            brgNumber: obj.bearing,
            dynamicRating: obj.dynamicRating,
        }));
    }, [firstPulley?.brgDiaSelected]);

    /* Min. Pulley Dia. 계산 */
    useEffect(() => {
        if (!minPulleyDiaByBelt) return;

        const minDiaByBelt = minPulleyDiaByBelt[firstPulley?.pulleyTypeCategory];
        const [minDiaByHubDia, minDiaByShapeRatio] = getMinPulleyDia(
            firstPulley?.beltWidth,
            firstPulley?.hubDiaSelected,
            firstPulley?.pulleyTypeCategory,
        );
        const minPulleyDia = Math.max(minDiaByBelt, minDiaByHubDia, minDiaByShapeRatio);

        setFirstPulley((prev) => ({
            ...prev,
            minPulleyDia,
            minDiaByBelt,
            minDiaByHubDia,
            minDiaByShapeRatio,
        }));

    }, [
        firstPulley?.beltWidth,
        firstPulley?.hubDiaSelected,
        firstPulley?.pulleyTypeCategory,
        minPulleyDiaByBelt,
    ]);

    /* Pulley Dia. with Lagging, RPM, Torque @Pulley Shaft 계산  */
    useEffect(() => {
        if (!firstPulley?.diaSelected || !firstPulley?.laggingThick || !slackSideTension || !tightSideTension) return;

        const diaWithLagging = Number(firstPulley.diaSelected) + Number(firstPulley.laggingThick) * 2;
        const rpm = (Number(beltSpeed) * 60) / ((Math.PI * diaWithLagging) / 1000);
        const torqueAtPulleyShaft = (Number(tightSideTension) - Number(slackSideTension)) * diaWithLagging / 2 / 10;    // mm -> cm 단위 환산

        setFirstPulley((prev) => ({
            ...prev,
            diaWithLagging,
            RPM: Math.round(rpm * 10) / 10,
            torqueAtPulleyShaft: Math.ceil(torqueAtPulleyShaft),
        }));
    }, [beltSpeed, firstPulley?.diaSelected, firstPulley?.laggingThick, slackSideTension, tightSideTension]);

    /* Pulley Weight 계산 */
    useEffect(() => {
        if (
            !firstPulley?.beltWidth ||
            !firstPulley?.hubDiaSelected ||
            !firstPulley?.brgDistance ||
            !firstPulley?.webDistance ||
            !firstPulley?.diaSelected ||
            !firstPulley?.laggingThick
        )
            return;

        const isDrive = true;

        const weight = getPulleyWeight(
            isDrive,
            firstPulley.beltWidth,
            firstPulley.hubDiaSelected,
            firstPulley.brgDistance,
            firstPulley.webDistance,
            firstPulley.diaSelected,
            firstPulley.laggingThick,
        );

        setFirstPulley((prev) => ({
            ...prev,
            weight,
        }));
    }, [
        firstPulley?.beltWidth,
        firstPulley?.hubDiaSelected,
        firstPulley?.brgDistance,
        firstPulley?.webDistance,
        firstPulley?.diaSelected,
        firstPulley?.laggingThick,
    ]);

    /* 리덕스에 쓰기 */
    useEffect(() => {
        if (!firstPulley) return;

        const newPulleys = [...nonDrivePulleys, firstPulley];

        /* pulleys를 indexArry에 따라 정렬하자. 입려할 때 순서가 바뀔수도 있다. */
        const indexArray = ['Drive', '1st Drive', '2nd Drive', 'Snub', 'Bend', 'Takeup', 'Tail', 'HTBend', 'LTBend'];
        const sortedPulleys = [...newPulleys].sort((a, b) => {
            const indexA = indexArray.indexOf(a?.application);
            const indexB = indexArray.indexOf(b?.application);

            if (indexA === indexB) {
                return a?.id - b?.id; // 동일한 application일 경우 id로 추가 정렬
            }

            // 만약 indexArray에 없는 application이 있다면, 정렬 순서에서 마지막으로 배치
            return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
        });

        dispatch(
            changeBody({
                key: 'pulleys',
                value: sortedPulleys,
            }),
        );

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, firstPulley]); // 왜 nonDrivePulleys를 의존성에서 지우니까 무한반복이 사라지나....'24.7/4

    if (!firstPulley) {
        return;
    }

    return (
        <>
            <Output
                label="Pulley Application"
                variable="-"
                unit="-"
                variableName="application"
                value={firstPulley.application}
            />
            <Output
                label="Pulley Type Category"
                variable="-"
                variableName="pulleyTypeCategory"
                unit="-"
                value={firstPulley.pulleyTypeCategory}
            />
            <Output
                label="Qty of Pulley(s)"
                variable="-"
                variableName="numberOfPulley"
                unit="ea"
                value={firstPulley.numberOfPulley}
            />
            <Input
                label="Resultant Force"
                variable="2U"
                variableName="resultantForce"
                unit="N"
                value={firstPulley.resultantForce}
                referenceValue={firstPulley.resultantForce}
                onChange={handleChange}
            />
            <Input
                label={
                    <AlertLabel
                        label={isEN ? "Tentative Torque @Pulley Shaft" : isJP ? "プーリ軸でのトルク（仮）" : "풀리 샤프트에서의 토크(임시)"}
                        message={isEN ? "First, enter the displayed torque to proceed with the calculation, and then re-enter the value after calculating the 'Torque at the pulley shaft' below." : isJP ? "まず表示されたトルクを入力して計算を進め、下の「プーリ軸でのトルク」が計算された後、その値を再入力してください。" : "우선 표시된 토크를 입력하여 계산을 진행하여 아래 '풀리 축에서의 토크'가 계산된 후 그 값을 재입력하세요."}
                    />
                }
                variable="T"
                variableName="torque"
                unit="N-cm"
                value={firstPulley.torque}
                referenceValue={firstPulley.tentativeTorque}
                onChange={handleChange}
            />
            <Input
                label="Eccentric Factor"
                variable="-"
                variableName="eccentricFactor"
                unit="-"
                value={firstPulley.eccentricFactor}
                referenceValue={1.1}
                onChange={handleChange}
            />
            <Output
                label="Max Moment"
                variable="Mmax"
                variableName="maxMoment"
                unit="N-cm"
                value={firstPulley.maxMoment}
            />
            <Output
                label="Bearing Center Distance"
                variable="L"
                variableName="brgDistance"
                unit="cm"
                value={firstPulley.brgDistance}
            />
            <Output
                label="Web Plate Center Distance"
                variable="L1"
                variableName="webDistance"
                unit="cm"
                value={firstPulley.webDistance}
            />
            <Output
                label="Length of Moment Arm"
                variable="L2"
                variableName="momentArm"
                unit="cm"
                value={firstPulley.momentArm}
            />
            <Output
                label="Shaft Dia. @Hub by Allowable Stress"
                variable="-"
                variableName="hubDiaByStress"
                unit="cm"
                value={firstPulley.hubDiaByStress}
            />
            <Output
                label="Shaft Dia. @Hub by Allowable Deflection(7')"
                variable="-"
                variableName="hubDiaByDeflection"
                unit="cm"
                value={firstPulley.hubDiaByDeflection}
            />
            <Output
                label="Shaft Dia. @Hub Selected"
                variable="-"
                variableName="hubDiaSelected"
                unit="cm"
                value={firstPulley.hubDiaSelected}
            />
            <Output
                label="Shaft Dia. @Bearing Calculated"
                variable="-"
                variableName="brgDiaCalculated"
                unit="cm"
                value={firstPulley.brgDiaCalculated}
            />
            <Select
                label="Bearing Dia. Selected"
                variable="-"
                variableName="brgDiaSelected"
                unit="cm"
                value={firstPulley.brgDiaSelected}
                options={brgDiaRankingRef.current}
                onChange={handleSelection}
                isRequired
            />
            <Output
                label="Plummer Block Number"
                variable="-"
                variableName="plummerBlockNumber"
                unit="-"
                value={firstPulley.plummerBlockNumber}
            />
            <Output
                label="Plummer Block Weight"
                variable="Fmax"
                variableName="plummerBlockWeight"
                unit="kg"
                value={firstPulley.plummerBlockWeight}
            />
            <Output
                label="Bearing Number"
                variable=""
                variableName="brgNumber"
                unit="-"
                value={firstPulley.brgNumber}
            />
            <Output
                label="Dynamic Rating"
                variable=""
                variableName="dynamicRating"
                unit="N"
                value={firstPulley.dynamicRating}
            />
            <Output
                label="L10h Life"
                variable=""
                variableName="lifeL10h"
                unit="hrs"
                value={firstPulley.lifeL10h}
            />
            <Output
                label="Min. Pulley Dia. w/o Lagging"
                variable="-"
                unit="mm"
                variableName="minPulleyDia"
                value={firstPulley.minPulleyDia}
            />
            <Output
                label="Min. Pulley Dia. by Belt"
                variable="-"
                unit="mm"
                variableName="minDiaByBelt"
                value={firstPulley.minDiaByBelt}
                isSub
            />
            <Output
                label="Min. Pulley Dia. by Hub Dia"
                variable="-"
                unit="mm"
                variableName="minDiaByHubDia"
                value={firstPulley.minDiaByHubDia}
                isSub
            />
            <Output
                label="Min. Pulley Dia. by Shape Ratio"
                variable="-"
                unit="mm"
                variableName="minDiaByShapeRatio"
                value={firstPulley.minDiaByShapeRatio}
                isSub
            />
            <Select
                label="Pulley Dia. Selected w/o Lagging"
                variable="-"
                variableName="diaSelected"
                unit="mm"
                value={firstPulley.diaSelected}
                options={standardPulleyDiaRef.current}
                onChange={handleSelection}
                isRequired
            />
            <Input
                label="Lagging Thickness"
                variable="-"
                unit="mm"
                variableName="laggingThick"
                value={firstPulley.laggingThick}
                onChange={handleChange}
            />
            <Output
                label="Pulley Dia. with Lagging"
                variable="-"
                unit="mm"
                variableName="diaWithLagging"
                value={firstPulley.diaWithLagging}
            />
            <Output
                label="Pulley RPM" 
                variable="RPM" 
                unit="1/min" 
                variableName="RPM" 
                value={firstPulley.RPM} 
            />
            <Output
                label={isEN ? "Torque At Pulley Shaft" : isJP ? "プーリ軸でのトルク" : "풀리축에 작용하는 토크"}
                variable="-" 
                unit="N-cm" 
                variableName="torqueAtPulleyShaft" 
                value={firstPulley.torqueAtPulleyShaft} 
            />
            <Output
                label="Estimated Pulley Weight"
                variable="-"
                unit="kg"
                variableName="weight"
                value={firstPulley.weight}
            />
        </>
    );
};

export default DrivePulleyFormSingle;
